import Vue from 'vue'
import mixins from '@/mixins'
import * as filters from '@/filter'
import '@/directives/perfect-scrollbar'
import $_ from '@/plugins/lodash' // 引入lodash
import { sync } from 'vuex-router-sync'

import useElementUI from './plugins/element'

// import VCharts from './plugins/echarts'

// main style sheet
import 'assets/sass/output.scss'
// import "assets/iconfont/iconfont.css"
import '@/styles/animation/index.less'

export default class {
  constructor(store, router) {
    // sync the router with the vuex store.
    // this registers `store.state.route`
    // store.state.route.path   // current path (string)
    // store.state.route.params // current params (object)
    // store.state.route.query  // current query (object)
    store && sync(store, router)

    // register global mixins.
    Vue.mixin(mixins)

    // register global utility filters.
    Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

    Vue.use($_)
    // Vue.use(VCharts)

    useElementUI(Vue)

    /**dev环境开启vue-dev-tools debug功能 */
    const debug = true //(process.env.SN_ENV || '').trim() !== 'prd'
    Vue.config.devtools = debug
    Vue.config.debug = debug
    Vue.config.warnExpressionErrors = debug
    Vue.config.productionTip = false
  }
}
